import { Entity, Key } from '@briebug/ngrx-auto-entity';

@Entity({ modelName: 'ContractExtraTotalTime' })
export class ContractExtraTotalTime {
  @Key id?: string;
  fieldLog: string;
  minutes: number;
}
